/**
 * Created by pmnia on 7/1/15.
 */
require('./data.module.js');
require('./advisor.services.js');
require('./association.services.js');
require('./booking.services.js');
require('./calendar.services.js');
require('./clinic.services.js');
require('./data.services.js');
require('./dynamic.services.js');
require('./form.services.js');
require('./login.services.js');
require('./page.services.js');
require('./preference.services.js');
require('./therapist.services.js');
require('./oracle.services.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/data.require.js
 ** module id = 157
 ** module chunks = 0
 **/